import {
  sanitizeHtmlForDisplay,
  sanitizeEmbedHtml,
  sanitizeModuleNameLink,
  hasPlainTextInjectionRisk,
  hasEmbedInjectionRisk,
  getInjectionRiskMessage,
} from '@/utils/xssSanitize';

function notifyXssInjectionRisk(vm, fieldName) {
  vm.$notify({
    type: 'danger',
    message: getInjectionRiskMessage(fieldName),
    icon: 'fas fa-exclamation-triangle',
  });
}

function validatePlainTextField(vm, fieldName, value) {
  if (hasPlainTextInjectionRisk(value)) {
    notifyXssInjectionRisk(vm, fieldName);
    return false;
  }
  return true;
}

function validatePlainTextFields(vm, fieldMap) {
  const fieldNames = Object.keys(fieldMap);
  for (let i = 0; i < fieldNames.length; i++) {
    const fieldName = fieldNames[i];
    if (!validatePlainTextField(vm, fieldName, fieldMap[fieldName])) {
      return false;
    }
  }
  return true;
}

function onXssPaste(vm, fieldName, event, hasRiskFn) {
  const clipboard = event.clipboardData || window.clipboardData;
  if (!clipboard) return;

  const pasted = clipboard.getData('text');
  if (hasRiskFn(pasted)) {
    event.preventDefault();
    notifyXssInjectionRisk(vm, fieldName);
  }
}

function normalizeKeywordItems(items) {
  if (Array.isArray(items)) {
    return items
      .map(function(k) { return String(k == null ? '' : k).trim(); })
      .filter(Boolean);
  }
  if (typeof items === 'string') {
    return items.split(',').map(function(k) { return k.trim(); }).filter(Boolean);
  }
  return [];
}

function validatePlainTextKeywordList(vm, fieldName, items) {
  const list = normalizeKeywordItems(items);
  for (let i = 0; i < list.length; i++) {
    if (hasPlainTextInjectionRisk(list[i])) {
      notifyXssInjectionRisk(vm, fieldName);
      return false;
    }
  }
  return true;
}

function filterPlainTextKeywordList(vm, fieldName, items) {
  const list = normalizeKeywordItems(items);
  const safe = [];
  let removed = false;
  for (let i = 0; i < list.length; i++) {
    const original = list[i];
    if (hasPlainTextInjectionRisk(original)) {
      removed = true;
      continue;
    }
    safe.push(original);
  }
  if (removed) {
    notifyXssInjectionRisk(vm, fieldName);
  }
  return safe;
}

export default {
  install(Vue) {
    Vue.prototype.$safeHtml = sanitizeHtmlForDisplay;
    Vue.prototype.$sanitizeEmbedHtml = sanitizeEmbedHtml;
    Vue.prototype.$sanitizeModuleNameLink = sanitizeModuleNameLink;
    Vue.prototype.$hasPlainTextInjectionRisk = hasPlainTextInjectionRisk;
    Vue.prototype.$hasEmbedInjectionRisk = hasEmbedInjectionRisk;

    Vue.prototype.$xssValidatePlainText = function(fieldName, value) {
      return validatePlainTextField(this, fieldName, value);
    };

    Vue.prototype.$xssValidatePlainTextFields = function(fieldMap) {
      return validatePlainTextFields(this, fieldMap);
    };

    Vue.prototype.$xssValidateEmbed = function(fieldName, value) {
      if (hasEmbedInjectionRisk(value)) {
        notifyXssInjectionRisk(this, fieldName);
        return false;
      }
      return true;
    };

    Vue.prototype.$xssOnPlainTextPaste = function(fieldName, event) {
      onXssPaste(this, fieldName, event, hasPlainTextInjectionRisk);
    };

    Vue.prototype.$xssOnEmbedPaste = function(fieldName, event) {
      onXssPaste(this, fieldName, event, hasEmbedInjectionRisk);
    };

    Vue.prototype.$xssValidatePlainTextKeywordList = function(fieldName, items) {
      return validatePlainTextKeywordList(this, fieldName, items);
    };

    Vue.prototype.$xssFilterPlainTextKeywordList = function(fieldName, items) {
      return filterPlainTextKeywordList(this, fieldName, items);
    };
  },
};
